import React from 'react';
import { colors } from './theme';
import { analyticsCardStyles as card } from './analytics/analyticsCardStyles';

function BarChart({ data }) {
  if (!data || data.length === 0) return null;
  const max = Math.max(...data.map(d => d.count));
  return (
    <div style={{ padding: '0.5rem 0' }}>
      {data.map(item => (
        <div key={item._id} style={{ display: 'flex', alignItems: 'center', marginBottom: '0.5rem' }}>
          <span style={{ flex: '0 0 90px', color: colors.textMuted }}>{item._id}</span>
          <div style={{ flex: 1, backgroundColor: 'rgba(255,255,255,0.07)', borderRadius: '999px', overflow: 'hidden', marginRight: '0.5rem' }}>
            <div style={{ height: '16px', width: `${(item.count / max) * 100}%`, backgroundColor: colors.accent, borderRadius: '10px' }} />
          </div>
          <span style={{ fontWeight: 'bold', color: colors.textStrong }}>{item.count}</span>
        </div>
      ))}
    </div>
  );
}

function DoughnutChart({ data, colorMap }) {
  if (!data || data.length === 0) return null;
  const total = data.reduce((s, d) => s + d.count, 0);
  const radius = 40;
  const circumference = 2 * Math.PI * radius;
  let cumulative = 0;
  return (
    <div style={{ position: 'relative', width: '100px', height: '100px' }}>
      <svg width="100" height="100" style={{ transform: 'rotate(-90deg)' }}>
        {data.map(d => {
          const dash = (d.count / total) * circumference;
          const dashArray = `${dash} ${circumference - dash}`;
          const circle = (
            <circle
              key={d._id}
              r={radius}
              cx="50"
              cy="50"
              fill="transparent"
              stroke={colorMap[d._id] || colors.accent}
              strokeWidth="20"
              strokeDasharray={dashArray}
              strokeDashoffset={-(cumulative / total) * circumference}
            />
          );
          cumulative += d.count;
          return circle;
        })}
      </svg>
      <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', fontWeight: 'bold', color: colors.textStrong }}>
        {total}
      </div>
    </div>
  );
}

export default function NciAnalyticsCard({ stats }) {
  if (!stats) return null;

  const categoryColors = {
    process: colors.accent,
    hardware: colors.success,
    cosmetic: colors.statusYellow,
    packaging: '#6c757d',
    other: '#17a2b8'
  };

  return (
    <div style={{ ...card.shell, maxWidth: '760px' }}>
      <div style={card.header}>
        <div style={card.titleWrap}>
          <p style={card.eyebrow}>Non-conformance</p>
          <h2 style={card.title}>NCI Analytics</h2>
        </div>
      </div>
      <div style={card.body}>
        <div style={card.statRow}>
          <span style={card.statLabel}>Total NCIs</span>
          <strong style={card.statValue}>{stats.total}</strong>
        </div>
        <section style={{ ...card.section, marginBottom: '1rem' }}>
          <h4 style={card.sectionTitle}>Submissions Over Time</h4>
          <BarChart data={stats.submissionsOverTime} />
        </section>
        <section style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
          <div style={{ ...card.section, flex: '1 1 220px' }}>
            <h4 style={card.sectionTitle}>By Category</h4>
            <DoughnutChart data={stats.byCategory} colorMap={categoryColors} />
            <ul style={{ listStyle: 'none', padding: 0, marginTop: '0.5rem', color: colors.textBody }}>
              {stats.byCategory.map(item => (
                <li key={item._id}>{item._id}: {item.count}</li>
              ))}
            </ul>
          </div>
          <div style={{ ...card.section, flex: '1 1 220px' }}>
            <h4 style={card.sectionTitle}>By Priority</h4>
            <DoughnutChart data={stats.byPriority} colorMap={{}} />
            <ul style={{ listStyle: 'none', padding: 0, marginTop: '0.5rem', color: colors.textBody }}>
              {stats.byPriority.map(item => (
                <li key={item._id}>{item._id}: {item.count}</li>
              ))}
            </ul>
          </div>
        </section>
      </div>
    </div>
  );
}
